import appbarstyles from './AppBarStyles.module.css';
import Toolbar from '@material-ui/core/Toolbar';
import InputBase from '@material-ui/core/InputBase';
import Button from '@material-ui/core/Button';
import AppBar from '@material-ui/core/AppBar';
import React, { Component } from 'react';

export default class NetworkToolbar extends Component {
  constructor() {
    super();
    this.state = {
      searchValue: '',
    };
  }
  loadNewPostPage = () => {
    window.location.href = 'https://de-waste.com/network/newPost';
  };
  render() {
    return (
      <AppBar
        position="static"
        color={'primary'}
        className={appbarstyles.appbar}
      >
        <Toolbar className={appbarstyles.toolbar}>
          <a
            href={'https://de-waste.com/network'}
            className={appbarstyles.logoAnchor}
          >
            <div className={appbarstyles.logoContainer}>
              <img
                src={'img/network_logo.png'}
                alt={'DeWaste'}
                className={appbarstyles.logo}
              />
            </div>
          </a>
          <div className={appbarstyles.search}>
            <InputBase
              placeholder="Search"
              inputProps={{ 'aria-label': 'search' }}
              style={{ width: '100%', marginLeft: '30px', color: '#ffffff' }}
              value={this.props.searchValue}
              onChange={this.props.handleChangeSearchValue}
              onKeyDown={this.props.checkEnter}
            />
          </div>
          <div className={appbarstyles.newPostButtonDiv}>
            <Button
              variant={'outlined'}
              className={appbarstyles.newPostButton}
              onClick={this.loadNewPostPage}
            >
              Make a New Post
            </Button>
          </div>
        </Toolbar>
      </AppBar>
    );
  }
}
